import { Component, Input, OnInit } from '@angular/core';
import { FileDto } from '@common/generated-api/models/file-dto';
import { CommonFilesApiService } from '@common/generated-api/services/common-files-api.service';
import { FilesService } from '@shared/services/files.service';

type CustomFileType = {
  name: string;
  size: number;
  uuid?: string;
};

@Component({
  selector: 'app-file-card',
  templateUrl: './file-card.component.html',
  styleUrls: ['./file-card.component.scss']
})
export class FileCardComponent implements OnInit {
  @Input() fileDto: FileDto;
  @Input() selectedFile: File;
  @Input() download: boolean;
  file: CustomFileType;

  constructor(
    private commonFilesApiService: CommonFilesApiService,
    private filesService: FilesService
  ) {
  }

  ngOnInit() {
    if (this.fileDto != null) {
      this.file = {
        name: this.fileDto.name,
        size: this.fileDto.fileSize,
        uuid: this.fileDto.uuid
      }
    } else {
      this.file = {
        name: this.selectedFile.name,
        size: this.selectedFile.size
      }
    }
  }

  downloadFile(file: CustomFileType) {
    this.filesService.downloadByUuid(file.uuid, file.name)
  }
}
